import React, { useState } from 'react';
import { Form, Button, Container, Alert, Spinner } from 'react-bootstrap';
import { useCreateInformationMutation } from '../slices/informationApiSlice'; // Adjust path as needed

const CreateInformationScreen = () => {
  const [information, setInformation] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const [createInformation, { isLoading, error }] = useCreateInformationMutation();

  const submitHandler = async (e) => {
    e.preventDefault();
    setSuccessMessage('');

    try {
      const infoData = { information };

      const result = await createInformation(infoData).unwrap();
      setSuccessMessage(`Information "${result.information}" created successfully!`);
      setInformation('');
    } catch (err) {
      // Error already handled via RTK Query's `error`
    }
  };

  const getErrorMessage = () => {
    if (error?.status === 400) {
      return error?.data?.message || 'Invalid input';
    }
    return 'An unexpected error occurred.';
  };

  return (
    <Container className="py-5">
      <h2 className="mb-4 text-center">Create New Information</h2>

      {error && <Alert variant="danger">{getErrorMessage()}</Alert>}
      {successMessage && <Alert variant="success">{successMessage}</Alert>}

      <Form onSubmit={submitHandler}>
        <Form.Group controlId="information" className="mb-3">
          <Form.Label>Information</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter information"
            value={information}
            onChange={(e) => setInformation(e.target.value)}
            required
          />
        </Form.Group>

        <Button type="submit" variant="primary" disabled={isLoading}>
          {isLoading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Submitting...
            </>
          ) : (
            'Submit Information'
          )}
        </Button>
      </Form>
    </Container>
  );
};

export default CreateInformationScreen;
